/* eslint-disable react/require-default-props */
import React from 'react';
import { useIntl } from 'react-intl';
import { DatePickerInput, FlexColumn, Input, Textarea, TimePickerInput } from 'design-system';

function getPreviewPlaceholder(intl, question) {
  const textType = question?.textType;

  switch (textType) {
    case 'email':
      return intl.formatMessage({ id: 'enter-email-address' });
    case 'phone':
      return intl.formatMessage({ id: 'enter-phone-no' });
    case 'name':
      return question?.placeholder || 'Enter your name';
    case 'date':
      return 'DD/MM/YYYY';
    case 'time':
      return 'HH:mm';
    default:
      return 'Enter your input';
  }
}

export default function TextTypeAnswer({
  question = null,
  preview = false,
  value = '',
  onChange,
  interactive = false,
  hasError = false,
}) {
  const intl = useIntl();
  const textType = question?.textType;
  const isMultiline = !textType || textType === 'textbox';
  const placeholder = preview
    ? getPreviewPlaceholder(intl, question)
    : intl.formatMessage({ id: 'enter-your-comment' });
  const fieldClassName = preview ? 'cc-preview-text-answer__field' : 'text-input has-float-label';
  const readOnly = preview && !interactive;

  if (interactive && textType === 'date') {
    return (
      <FlexColumn align="stretch" fullWidth className="cc-preview-text-answer">
        <DatePickerInput
          className="cc-preview-text-answer__field"
          overlayClassName="cc-preview-date-picker-overlay"
          value={value ?? ''}
          onChange={onChange}
          allowFutureDate={Boolean(question?.allow_future_date)}
          placeholder={preview ? getPreviewPlaceholder(intl, question) : 'DD/MM/YYYY'}
          error={hasError}
        />
      </FlexColumn>
    );
  }

  if (interactive && textType === 'time') {
    return (
      <FlexColumn align="stretch" fullWidth className="cc-preview-text-answer">
        <TimePickerInput
          className="cc-preview-text-answer__field"
          overlayClassName="cc-preview-time-picker-overlay"
          value={value ?? ''}
          onChange={onChange}
          defaultToCurrentTime
          placeholder={preview ? getPreviewPlaceholder(intl, question) : 'HH:mm'}
          error={hasError}
        />
      </FlexColumn>
    );
  }

  return (
    <FlexColumn align="stretch" fullWidth className={preview ? 'cc-preview-text-answer' : 'mt-2'}>
      {isMultiline ? (
        <Textarea
          rows={preview ? 1 : 3}
          className={fieldClassName}
          placeholder={placeholder}
          value={value ?? ''}
          readOnly={readOnly}
          error={hasError}
          onChange={(event) => onChange?.(event.target.value)}
        />
      ) : (
        <Input
          type={textType === 'phone' ? 'tel' : 'text'}
          phone={textType === 'phone'}
          className={fieldClassName}
          placeholder={placeholder}
          value={value ?? ''}
          readOnly={readOnly}
          error={hasError}
          onChange={(event) => {
            if (textType === 'phone') {
              onChange?.(String(event.target.value).replace(/\D/g, ''));
              return;
            }
            onChange?.(event.target.value);
          }}
        />
      )}
    </FlexColumn>
  );
}
